import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

import { ExternalPatientSubscriptionInfo, ExternalPatientSubscriptionInfoIcon } from "@/Common/Api/Patient/Dto/PatientSubscriptions/ExternalPatientSubscriptionInfo";
import { Patient } from "@/Common/Models/Patient/Patient";
import { BaseReactComponent } from "../../BaseReactComponent";

import styles from "./PatientSubscription.module.scss";

import Img_lacroix_icon_expired from "@/Common/_images/MSP_NotRegistered.svg";
import Img_lacroix_icon_registered from "@/Common/_images/MSP_Registered.svg";
import Img_lacroix_icon_not_registered from "@/Common/_images/PBF_NotRegistered.svg";

interface IPatientSubscriptionProps {
    patient: Patient;
}

/**
 * Component for displaying a patient's subscription information.
 *
 * @remarks
 * - Renders a list of patient subscriptions with status icons and descriptions.
 * - Uses ReactMarkdown with raw HTML support to render subscription text.
 *
 * @extends BaseReactComponent
 *
 * @param props - The properties for the PatientSubscription component.
 * @property props.patient.ExternalPatientSubscriptionFreeText - Array of subscription info objects to display.
 */
class PatientSubscription extends BaseReactComponent<IPatientSubscriptionProps, any> {
    public constructor(props: IPatientSubscriptionProps) {
        super(props);
    }

    public render(): JSX.Element {
        const patientSubscriptions = this.props.patient.ExternalPatientSubscriptionInfo ?? [];
        return (
            <ul>
                {patientSubscriptions.map((subscription, index) => (
                    <li key={`patientsubcription_${subscription.ExternalSubscriptionId ?? index}`} title={subscription?.Description}>
                        {this.renderPatientSubscription(subscription)}
                    </li>
                ))}
            </ul>
        );
    }

    private getStatusIcon(statusEnum: ExternalPatientSubscriptionInfoIcon): JSX.Element {
        const iconMap = {
            [ExternalPatientSubscriptionInfoIcon.NotRegisteredMark]: Img_lacroix_icon_not_registered,
            [ExternalPatientSubscriptionInfoIcon.RedX]: Img_lacroix_icon_expired,
            [ExternalPatientSubscriptionInfoIcon.GreenCheckMark]: Img_lacroix_icon_registered
        };
        const IconComponent = iconMap[statusEnum];
        return IconComponent ? <IconComponent className={styles.subscriptionImageIcon} /> : <></>;
    }

    private renderPatientSubscription(subscription: ExternalPatientSubscriptionInfo): JSX.Element {
        const rehypeRawPlugin: any = rehypeRaw;
        return (
            <div className={styles.patientSubscription}>
                <span className="no-margin-icon">
                    {this.getStatusIcon(subscription.Icon)}
                </span>

                <span className={styles.subscriptionText}>
                    <ReactMarkdown
                        rehypePlugins={[rehypeRawPlugin]}
                    >
                        {subscription.ShortDescription}
                    </ReactMarkdown>
                </span>
            </div>
        );
    }
}
export { PatientSubscription };
